import { HttpHandler } from './HttpHandler';
import { environment } from '../enviroments';

export const PAYMENT_INTENT_API_PATH = `${environment.STRIPE_PAYMENTS_APP_URL}/payment-intent`;
const SUBSCRIPTION_API_PATH = `${environment.STRIPE_PAYMENTS_APP_URL}/subscription`;

export const applyCouponToPaymentIntent = async (paymentIntentId: string, couponCode: string) => {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${PAYMENT_INTENT_API_PATH}/${paymentIntentId}/coupon/${couponCode}/apply`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const clearCouponFromPaymentIntent = async (paymentIntentId: string, couponCode: string) => {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${PAYMENT_INTENT_API_PATH}/${paymentIntentId}/coupon/${couponCode}/clear`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const applyCouponToSubscription = async (subscriptionId: string, couponCode: string) => {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${SUBSCRIPTION_API_PATH}/${subscriptionId}/coupon/${couponCode}/apply`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const clearCouponFromSubscription = async (subscriptionId: string, couponCode: string) => {
  const { data } = await HttpHandler({
    method: 'POST',
    url: `${SUBSCRIPTION_API_PATH}/${subscriptionId}/coupon/${couponCode}/clear`,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return data.data;
};

export const getCouponBalanceAvailability = async (specialistID: string) => {
  const { data } = await HttpHandler({
    method: 'GET',
    url: `${environment.COUPONS_APP_URL}/client/balance/covers-session/${specialistID}`,
  });

  return data.data;
};